import {useDispatch} from 'react-redux';

import {isEmpty, isNil} from 'ramda';

import {metadaWorkshopServiceOrderJobApi} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

export function useInvalidateServiceOrderJobs(serviceOrderId: string | Nullish) {
  const dispatch = useDispatch();

  return () => {
    if (isNil(serviceOrderId) || isEmpty(serviceOrderId)) {
      return;
    }

    dispatch(
      metadaWorkshopServiceOrderJobApi.util.invalidateTags([
        {type: 'serviceOrderJobs', id: serviceOrderId},
      ])
    );
  };
}
